// extracted by mini-css-extract-plugin
export default {"BetaLabel":"_BetaLabel--SICS9"};